import { CurrencyEnum, OrderSideEnum } from '../../enums/index';
import { OrderTypeEnum } from '../../enums/order-type.enum';
import { GatewayRequestType } from '../../services/web-socket/types';
import {
  QueryCacheItemType,
} from '../gateway/types';

export type TradingConfig = {
  exDestination: string
  subDestination: string
}

export enum GetDetailsFunctionalityType {
  getPositions = 'getPositions',
  getOrders = 'getOrders',
  getOrderHistory = 'getOrderHistory',
  getTransactions = 'getTransactions',
  getBalances = 'getBalances'
}

export type Balance = {
  account: string;
  // All below are number strings - for example '136.83'
  availBp: number;
  equity?: number;
  equityPlusRpnl?: number;
  ordExp?: number;
  posExp?: number;
  rpnl?: number;
  totalBp?: number;
  usedBp?: number;
  accountCurrency: CurrencyEnum;
};

export type BuyingPower = {
  baseCurrency: CurrencyEnum;
  buyingPowerId: number;
  accountReferenceId: string;
};

export type RawBalanceData = Pick<Balance, 'account'> & {
  availBp: string;
  equity: string;
  equityPlusRpnl: string;
  ordExp: string;
  posExp: string;
  rpnl: string;
  totalBp: string;
  usedBp: string;
  accountCurrency: CurrencyEnum;
};

export type QueriesCacheType = { [key: string]: QueryCacheItemType }

export interface Order {
  status?: string;
  reqId?: string;
  rc?: string;
  requestType?: GatewayRequestType | null;
  account?: string;
  clientOrderId?: string;
  symbol?: string;
  side?: OrderSideEnum;
  orderQty?: number;
  ordType?: OrderTypeEnum;
  price?: number;
  stopPrice?: number;
  exDestination?: string;
  subDestination?: string;
  createdAt?: string;
  updatedAt?: string;
  error?: string;
  avgPriceSoFar?: number;
  filledSoFar?: number;
  fills?: Execution[];
  destination?: string;
  originalClientOrderId?: string;
  traceIdentifier?: string;
  rejectReport?: { text?: string };
}

export type RawOrderData = Omit<Order, 'price' | 'stopPrice' | 'orderQty' | 'fills'> & {
  orderQty?: string;
  price?: string;
  stopPrice?: string;
  fills?: RawExecutionData[];
  avgPriceSoFar?: string; // "3550.00000000",
}

export type OrdersMap = { [key: string]: Order };

export type Position = {
  symbol: string;
  qty: number;
  avgPrice: number;
}
export type RawPositionData = Omit<Position, 'qty' | 'avgPrice' > & {
  qty: string; // number string - for example '8'
  avgPrice: string; // number string - for example '136.83920'
}

/** OMS variant */
export type Execution = {
  parentOrder?: Order;
  execId: string; // "070610150001098"
  timeStamp: string // "2021-07-06T15:24:27.017Z"
  fillQty: number;
  fillPrice: number;
}

/** OMS variant */
export type RawExecutionData = Pick<Execution, 'execId' | 'timeStamp'> &{
  fillPrice: string // "3550.0",
  fillQty: string // "1"
}

export enum FXType {
  ForexMarket = 19,
  ForexLimit = 22
}

export type FXOrderPayload = {
  quantity: number;
  side: OrderSideEnum;
  symbol: string;
  currency: CurrencyEnum;
  settlCurrency: CurrencyEnum;
  type: FXType;
}

export type FXOrderRequest = Omit<FXOrderPayload, 'quantity'> & {
  account: string;
  clOrdId: string;
  orderQty: number;
  dateTime: string;
  messageType: GatewayRequestType;
  traceIdentifier: string;
  exDestination: string;
  capacity: string;
};

export type BPRequestParam = { countryDesignation?: string }
